import { all, call, select, put, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {
    try {
        const { auditId } = action.payload;
        const { data } = yield call(
            http.authorized.get,
            `${config.api.paths.assignmentDetails}?audit_id=${auditId}`
        );
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On fetching assignment details:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ASSIGNMENT_DETAILS_GET_REQUEST, getRequest)
    ]);
}
